import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentFilters,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
} from '@griply/types';
import isEqual from 'lodash/isEqual';

export const isDefaultFilterDocument = <
  GBM extends GroupByMode,
  SM extends SortingMode,
  F extends FilterOptionKeys,
>(
  filterDocument: FilterDocument<GBM, SM, F>,
  defaultFilterDocument: FilterDocument<GBM, SM, F> = {},
  supportedFilters?: F[],
) => {
  // easiest check, for when default filters are
  if (isEqual(filterDocument, defaultFilterDocument)) {
    return true;
  }

  if (
    !filterDocument[DocumentOrganizationKeys.Filters] &&
    !!defaultFilterDocument[DocumentOrganizationKeys.Filters]
  ) {
    return false;
  }

  const defaultFilterDocumentFilters =
    defaultFilterDocument[DocumentOrganizationKeys.Filters] ??
    ({} as Pick<FilterDocumentFilters, F>);
  const defaultActiveFilters = Object.keys(defaultFilterDocumentFilters)
    .filter((key) => !supportedFilters || supportedFilters.includes(key as F))
    .filter((key) => {
      const val = defaultFilterDocumentFilters[key as F];
      return !val
        ? false
        : Array.isArray(val)
          ? !!val?.length
          : typeof val === 'object'
            ? Object.values(val).some(Boolean)
            : !!val;
    });

  const filterDocumentFilters =
    filterDocument[DocumentOrganizationKeys.Filters] ??
    ({} as Pick<FilterDocumentFilters, F>);
  const activeFilters = Object.keys(filterDocumentFilters).filter((key) => {
    if (supportedFilters && !supportedFilters.includes(key as F)) {
      return false;
    }

    const val = filterDocumentFilters[key as F];
    return !val
      ? false
      : Array.isArray(val)
        ? !!val?.length
        : typeof val === 'object'
          ? Object.values(val).some(Boolean)
          : !!val;
  });

  if (activeFilters.length !== defaultActiveFilters.length) {
    return false;
  }

  return !activeFilters.some((key) => {
    if (!defaultActiveFilters.includes(key)) {
      return true;
    }

    const val = filterDocumentFilters[key as F];
    const defaultVal = defaultFilterDocumentFilters[key as F];

    return !isEqual(val, defaultVal);
  });
};
